export const EMPRESAS_LOADING = 'EMPRESAS_LOADING';
export const EMPRESAS_DATA = 'EMPRESAS_DATA';
export const EMPRESA_DATA = 'EMPRESA_DATA';
export const EMPRESAS_CLIENTES_DATA = 'EMPRESAS_CLIENTES_DATA';
export const EMPRESAS_SELECIONADA_DATA = 'EMPRESAS_SELECIONADA_DATA';


export const EMPRESAS_DATA_PAGE = "EMPRESAS_DATA_PAGE";
export const EMPRESAS_DATA_PER_PAGE = "EMPRESAS_DATA_PER_PAGE";
export const EMPRESAS_DATA_TOTAL = "EMPRESAS_DATA_TOTAL";

// USUARIOS EMPRESA
export const USUARIOS_EMPRESAS_DATA = "USUARIOS_EMPRESAS_DATA";
export const USUARIOS_EMPRESAS_DATA_PAGE = "USUARIOS_EMPRESAS_DATA_PAGE";
export const USUARIOS_EMPRESAS_DATA_PER_PAGE = "USUARIOS_EMPRESAS_DATA_PER_PAGE";
export const USUARIOS_EMPRESAS_DATA_TOTAL = "USUARIOS_EMPRESAS_DATA_TOTAL";
export const EMPRESA_SELECIONADA_USUARIOS = "EMPRESA_SELECIONADA_USUARIOS";

export const EMPRESAS_CLIENTES_DATA_PAGE = "EMPRESAS_CLIENTES_DATA_PAGE"; 
export const EMPRESAS_CLIENTES_DATA_VALIDATION = "EMPRESAS_CLIENTES_DATA_VALIDATION"; 
export const EMPRESAS_CLIENTES_DATA_PER_PAGE = "EMPRESAS_CLIENTES_DATA_PER_PAGE";
export const EMPRESAS_CLIENTES_DATA_TOTAL = "EMPRESAS_CLIENTES_DATA_TOTAL";